import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled(FlexContainer)`
  border: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_L};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    overflow: hidden;
    width: 100%;
  }
`;

export const Content = styled(FlexContainer)`
  max-width: 450px;
  overflow: auto;
  padding: ${({ theme: { reference } }) => reference.dimension_16};
`;

export const ButtonsContainer = styled(FlexContainer)`
  border-top: 1px solid ${({ theme }) => theme.colors.moon_500};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    position: sticky;
  }
`;
